var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconQuote = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3118",
  d: "m11.176 17.744 8.934-11.3V6h-5.126l-7.323 9.233C4.732 18.926 4 20.773 4 25.573V32h12.961V19.739h-5.565c-.952 0-1.245-.665-.22-1.995M19.89 32h12.961V19.739h-5.565c-.952 0-1.245-.665-.22-1.995L36 6.444V6h-5.126l-7.322 9.233c-2.93 3.693-3.662 5.54-3.662 10.34z"
})));
export default SvgIconQuote;